import { render } from "./CartridgeModal.vue?vue&type=template&id=0f23fcf7&scoped=true"
import script from "./CartridgeModal.vue?vue&type=script&lang=ts"
export * from "./CartridgeModal.vue?vue&type=script&lang=ts"

import "./CartridgeModal.vue?vue&type=style&index=0&id=0f23fcf7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f23fcf7"

export default script